import React, { useState } from 'react'
import {
  Button,
  Card,
  Col,
  Form,
  Icon,
  Input,
  Divider,
  Modal,
  Row,
  Upload
} from 'antd'
import { isEmpty, isNull, isNil } from 'lodash'
import {
  beforeUpload,
  uploadBarcodeRecycleImage,
  getBase64
} from '../../../utils/services'
import { useDeepEffect } from '../../../utils/hooks'
import { SelectMaterialDiv } from '../../../styles/shared.style'
import { useSelector } from 'react-redux'
import BarcodeMaterialModal from '../../Brand/BrandProduct/BarcodeMaterialModal'
import SelectImg from '../../../assets/images/select_item.png'
import AddMaterialImg from '../../../assets/images/add_material_icon.png'

const EditRecycleBarcodeProduct = ({
  formData,
  visible,
  onCancel,
  onOk,
  form
}) => {
  const {
    validateFields,
    getFieldDecorator,
    getFieldValue,
    setFieldsValue,
    resetFields
  } = form

  const { barcodeRecycleItems } = useSelector(
    (state) => ({
      barcodeRecycleItems: state.barcodeProduct.barcodeRecycleItems
    }),
    []
  )

  getFieldDecorator('keys', { initialValue: [] })
  const keys = getFieldValue('keys')
  const [formImg, setFormImg] = useState([])
  const [materialForm, setMaterialForm] = useState({})
  const [visibleAddMaterial, setVisibleAddMaterial] = useState(false)

  useDeepEffect(() => {
    if (!isEmpty(formData) && !isNil(formData)) {
      if (!isEmpty(barcodeRecycleItems) && !isNil(barcodeRecycleItems)) {
        const arr = barcodeRecycleItems.map((item) => {
          return {
            materialId: item.materialId,
            materialName: item.materialName,
            materialImageUrl: item.materialImage,
            imageUrl: item.imageUrl,
            recycleDetail: item.recycleDetail,
            barcodeRecycleId: item.barcodeRecycleId,
            barcodeId: item.barcodeId,
            id: item.id
          }
        })
        setFieldsValue({
          keys: arr
        })
      } else {
        setFieldsValue({
          keys: [{ id: 0, idx: 0 }]
        })
      }
    }
  }, [formData])

  function add() {
    const keys = getFieldValue('keys')
    const index = keys.length
    keys.push({
      id: 0,
      idx: index
    })
    setFieldsValue({
      keys: keys
    })
    setFormImg((prevState) => {
      prevState.push('')
      return [...prevState]
    })
  }

  function remove(e, k, idx) {
    e.preventDefault()
    const keys = getFieldValue('keys')
    if (k !== 0) {
      setFieldsValue({
        keys: keys.filter((key) => key.id !== k)
      })
    } else {
      setFieldsValue({
        keys: keys.filter((key, index) => index !== idx)
      })
    }
  }

  function onClickAddMaterial(e, item, index) {
    e.preventDefault()
    setMaterialForm(item)
    setVisibleAddMaterial(true)
  }

  function onOkAddMaterial(data) {
    for (const item of keys) {
      if (data.idx) {
        if (data.idx === item.idx) {
          item.materialId = data.materialId
          item.materialName = data.materialName
          item.materialImageUrl = data.materialImageUrl
        }
      } else {
        if (data.id === item.id && data.id !== 0) {
          item.materialId = data.materialId
          item.materialName = data.materialName
          item.materialImageUrl = data.materialImageUrl
        }
      }
    }
    setVisibleAddMaterial(false)
  }

  function onClose() {
    setVisibleAddMaterial(false)
  }

  async function handleChange(info, index) {
    await getBase64(info.file, (imageUrl) => {
      setFormImg((prevState) => {
        prevState[index] = imageUrl
        return [...prevState]
      })
    })
  }

  async function handleSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const { keys, images, recycleDetails } = values
        const data = []
        for (let i = 0; i < keys.length; i++) {
          let imageUrl = ''
          let img = null
          if (!isNil(images[i])) {
            img = await uploadBarcodeRecycleImage(images[i].file)
            imageUrl = img.url ? img.url : ''
          } else {
            imageUrl = keys[i].imageUrl
          }

          data.push({
            materialId: keys[i].materialId,
            recycleDetail: recycleDetails[i],
            recycleIndex: i,
            recycleItemId: keys[i].id,
            imageUrl: imageUrl,
            barcodeRecycleId: keys[i].barcodeRecycleId
              ? keys[i].barcodeRecycleId
              : 0,
            barcodeId: keys[i].barcodeId ? keys[i].barcodeId : formData.id
          })
        }

        await onOk(data)
        await form.resetFields()
        await setFormImg([])
      }
    })
  }

  return (
    <Modal
      width={800}
      title="วิธีคัดแยก"
      visible={visible}
      closable={false}
      footer={null}>
      <BarcodeMaterialModal
        materialForm={materialForm}
        visible={visibleAddMaterial}
        onOk={onOkAddMaterial}
        onCancel={onClose}
      />
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Row type="flex" justify="center">
            <span>{formData.name}</span>
          </Row>
        </Col>
        <Col span={24}>
          <Form onSubmit={handleSubmit}>
            <Row gutter={[8, 8]}>
              {!isEmpty(keys) &&
                keys.map((item, index) => {
                  return (
                    <Col span={24} key={index}>
                      <Card>
                        <Row gutter={[8, 8]}>
                          <Col span={24}>
                            <Row type="flex" justify="space-between">
                              <Col>ขยะชิ้นที่ {index + 1}</Col>
                              {index !== 0 && (
                                <Col>
                                  <Button
                                    type="danger"
                                    onClick={(e) => remove(e, item.id, index)}>
                                    ลบ
                                  </Button>
                                </Col>
                              )}
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Row type="flex">
                              <Col span={8}>
                                <Row type="flex" justify="center">
                                  <Form.Item
                                    key={item.id === 0 ? item.idx : item.id}>
                                    {getFieldDecorator(`images[${index}]`, {
                                      rules: [
                                        {
                                          required: isNull(formData),
                                          message: 'เลือกรูปภาพ'
                                        }
                                      ]
                                    })(
                                      <Upload
                                        name="avatar"
                                        listType="picture-card"
                                        showUploadList={false}
                                        beforeUpload={(file) =>
                                          beforeUpload(file)
                                        }
                                        onChange={(info) =>
                                          handleChange(info, index)
                                        }>
                                        {!isNil(item.imageUrl) ||
                                        !isNil(formImg[index]) ? (
                                          <img
                                            src={
                                              formImg[index]
                                                ? formImg[index]
                                                : item.imageUrl
                                            }
                                            alt="avatar"
                                            width={114}
                                            height={114}
                                          />
                                        ) : (
                                          <img
                                            src={SelectImg}
                                            alt=""
                                            width={114}
                                            height={114}
                                          />
                                        )}
                                      </Upload>
                                    )}
                                  </Form.Item>
                                </Row>
                              </Col>
                              <Col span={8}>
                                <Row
                                  style={{ marginTop: '30px' }}
                                  type="flex"
                                  justify="center"
                                  align="middle">
                                  <Col>
                                    <Icon
                                      type="arrow-right"
                                      style={{ fontSize: 64 }}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={8}>
                                <Row type="flex" justify="center">
                                  {item.materialImageUrl ? (
                                    <SelectMaterialDiv
                                      onClick={(e) =>
                                        onClickAddMaterial(e, item, index)
                                      }>
                                      <Row gutter={[8, 8]}>
                                        <Col span={24}>
                                          <Row type="flex" justify="center">
                                            <Row type="flex" justify="center">
                                              <img
                                                src={item.materialImageUrl}
                                                alt=""
                                                width={64}
                                                height={64}
                                              />
                                            </Row>
                                          </Row>
                                        </Col>
                                        <Col span={24}>
                                          <Row type="flex" justify="center">
                                            <span>{item.materialName}</span>
                                          </Row>
                                        </Col>
                                      </Row>
                                    </SelectMaterialDiv>
                                  ) : (
                                    <img
                                      style={{ cursor: 'pointer' }}
                                      onClick={(e) =>
                                        onClickAddMaterial(e, item, index)
                                      }
                                      src={AddMaterialImg}
                                      alt=""
                                      width={128}
                                      height={128}
                                    />
                                  )}
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Form.Item
                              label="เขียนรายะเอียดหรือวิธีการจัดการเพื่อได้ขยะชิ้นนี้"
                              key={item.id === 0 ? item.idx : item.id}>
                              {getFieldDecorator(`recycleDetails[${index}]`, {
                                initialValue: item.recycleDetail
                              })(
                                <Input.TextArea
                                  autoSize={{ minRows: 3 }}
                                  maxLength={128}
                                />
                              )}
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  )
                })}
            </Row>
            <Row gutter={[8, 8]} style={{ marginTop: 15 }}>
              <Col span={24}>
                <Row type="flex" justify="center" gutter={8}>
                  <Col>
                    <Button type="primary" onClick={() => add()}>
                      เพิ่มขยะ
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Divider />
                <Row type="flex" justify="end" gutter={8}>
                  <Col>
                    <Button
                      onClick={() => {
                        resetFields()
                        onCancel()
                        setFormImg([])
                      }}>
                      Cancel
                    </Button>
                  </Col>
                  <Col>
                    <Button type="primary" htmlType="submit">
                      Save
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Modal>
  )
}

const WrappedEditRecycleBarcodeProduct = Form.create({
  name: 'EditRecycleBarcodeProduct'
})(EditRecycleBarcodeProduct)
export default WrappedEditRecycleBarcodeProduct



// WEBPACK FOOTER //
// ./src/pages/RecycleBarcodeProduct/EditRecycleBarcodeProduct/index.js